// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3FVVH","label":"Completed_label__5asCI"};